import React from 'react';

import { TableCell, TableHeaderCell } from '@hcs/design-system';
import { TableCellProps, TableHeaderCellProps } from '@hcs/types';

import { DATA_HC_NAME_ORDER_ITEMS_TABLE_CELL } from '../../constants';
import { OrderItem } from '../../types';

import { DisplayProps } from '.';

// eslint-disable-next-line react-refresh/only-export-components
const Display = ({ orderItem }: DisplayProps): JSX.Element | null => {
  return (
    <div data-hc-name={`${DATA_HC_NAME_ORDER_ITEMS_TABLE_CELL}-id`}>
      {orderItem?.customerItemId}
    </div>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
const HeaderCell = ({ ...tableHeaderCellProps }) => {
  return <TableHeaderCell {...tableHeaderCellProps}>ID</TableHeaderCell>;
};

const defaultHeaderCellProps: Partial<TableHeaderCellProps> = {
  isTableHeaderCell: true,
};

HeaderCell.defaultProps = defaultHeaderCellProps;

// eslint-disable-next-line react-refresh/only-export-components
const ContentCell = ({
  orderItem,
  ...tableCellProps
}: {
  orderItem: OrderItem;
}) => {
  return (
    <TableCell {...tableCellProps}>
      <Display orderItem={orderItem} />
    </TableCell>
  );
};

const defaultContentProps: Partial<TableCellProps> = {
  isTableCell: true,
};

ContentCell.defaultProps = defaultContentProps;

export const ORDER_ITEM_CUSTOMER_ITEM_ID_CONFIG = {
  HeaderCell,
  ContentCell,
  label: 'ID',
  sortable: true,
};
